// :cow: Cosmose CONFIDENTIAL :iso:
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

marker('BRANDS');
marker('FLOORS');
marker('GROUPS');
marker('LOCATIONS');
marker('STORES');

export enum SelectableFeature {
  BRANDS = 'brands',
  FLOORS = 'floors',
  GROUPS = 'groups',
  LOCATIONS = 'locations',
  STORES = 'stores'
}

export enum SelectableType {
  COMPARE = 'compare',
  CREATE_GROUP = 'createGroup'
}

